import { render } from "./superturbo.vue?vue&type=template&id=0ecb0cc3&scoped=true"
import script from "./superturbo.vue?vue&type=script&lang=js"
export * from "./superturbo.vue?vue&type=script&lang=js"

import "./superturbo.vue?vue&type=style&index=0&id=0ecb0cc3&scoped=true&lang=css"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0ecb0cc3"]])

export default __exports__